export default "__VITE_ASSET__CMr$EEo4__"